import type { Action } from "../types";
import { timestampDateInTokyo } from "./date";

export function mergeNewActionIdsAtTop(previous: string[], current: string[]): string[] {
  const currentIds = new Set(current);
  const kept = previous.filter((id) => currentIds.has(id));
  const keptIds = new Set(kept);
  const added = current.filter((id) => !keptIds.has(id));
  return [...added, ...kept];
}

function remindsOn(action: Action, date: string): boolean {
  if (!action.reminder_on) return false;
  return action.reminder_mode === "once"
    ? action.reminder_on === date
    : action.reminder_on <= date;
}

function appearsOnToday(action: Action, date: string): boolean {
  if (action.today_override_on === date && action.today_override_visible !== null && action.today_override_visible !== undefined) {
    return action.today_override_visible;
  }
  return remindsOn(action, date);
}

export function actionsForDaily(actions: Action[], date: string, today: string): Action[] {
  if (date === today) {
    return actions.filter((action) => !action.completed_at && appearsOnToday(action, today));
  }
  return actions.filter((action) => Boolean(action.completed_at && timestampDateInTokyo(action.completed_at) === date));
}

export function candidatesForToday(actions: Action[], today: string): Action[] {
  return actions.filter((action) => !action.completed_at && !appearsOnToday(action, today));
}
